<template>
  <input
    ref="search"
    :placeholder="placeholder"
    :value="searchTerm"
    type="text"
    class="search"
    @keyup="debounceSearchStakeholdersByName"
  >
</template>

<script>
import { mapActions, mapState } from "vuex";
import { debounce as _debounce, isEmpty as _isEmpty } from "lodash";

export default {
  name: "StakeholderSearch",
  inject: {
    stakeholderService: { from: "stakeholderService" },
    eventsBus: { from: "eventsBus" }
  },
  props: {
    autosearch: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapState("wdyk", {
      searchTerm: state => state.searchTerm
    })
  },
  activated() {
    this.eventsBus.$on("clearSearch", this.clearSearch);
  },
  deactivated() {
    this.eventsBus.$off("clearSearch", this.clearSearch);
  },
  methods: {
    ...mapActions({
      clearSearchStakeholders: "wdyk/clearSearchStakeholders",
      setLoading: "wdyk/loading"
    }),
    clearSearch() {
      this.$refs.search.value = null;
    },
    debounceSearchStakeholdersByName: _debounce(async function() {
      if (this.autosearch) {
        await this.search();
      }
    }, 1000),
    async search() {
      const name = this.$refs.search.value;
      this.eventsBus.$emit("showRelationshipForm", false);
      this.setLoading(true);
      this.clearSearchStakeholders();

      const searchStakeholders = await this.stakeholderService.findByName(name);

      if (!_isEmpty(searchStakeholders)) {
        this.eventsBus.$emit(
          "updateSearchStakeholdersLastBatch",
          searchStakeholders
        );
      }
      this.setLoading(false);
    }
  }
};
</script>
